export default "__VITE_ASSET__CAOLPNYb__"